import React, { Component } from 'react'

import { withRouter, Route, Redirect, Switch } from 'react-router-dom';
import Search from './web/components/Search'
import Layout from './web/components/Layout'
import Paid from './web/components/Paid'
import Login from './web/components/Login'
import Logout from './web/components/Logout'
import './web/css/suggest.css'
import './web/css/fix.css'
import './web/css/web.css'
import Auth from './Auth'
import Category from './web/components/Category'
import { ViewTemplate } from './web/components/ViewTemplate'
import { Order } from './web/components/Order'
import AliPay from './web/components/AliPay'
import WechatPay from './web/components/WechatPay'
import NotFound from './web/components/NotFound'
import Source from './Source'

const auth = new Auth();
const source = new Source();
export class Web extends Component {
    
    componentDidMount() {
      
    }

    render() {
        return (
            <Layout>
                <Switch>
                    <Route exact path="/" component={Category} />

                    <Route path="/Search" component={Search} />

                    <Route path="/Login" component={Login} />
                    <PrivateRoute path="/Paid" component={Paid} />
                    <Route path="/Logout" component={Logout} />
                    <Route path="/Order" component={Order} />
                    <Route path="/AliPay" component={AliPay} />
                    <Route path="/WechatPay" component={WechatPay} />
                    <Route path="/NotFound" component={NotFound} />
                    <Route exact path="/:id" component={ViewTemplate} />

                </Switch>

            </Layout>
        )
    }
}

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            auth.isSign() ? (
                <Component {...props} />
            ) : (
                    <Redirect
                        to={{
                            pathname: "/Login",
                            state: { from: props.location }
                        }}
                    />
                )
        }
    />
);

export default withRouter(Web)